import * as Yup from "yup";

export const initialValuesInmueble = {
    name: "",
    address: "",
    type: "",
    real_estate: null,
    isMortgaged: false,
    isRented: false,
    airbnbDocuments: [],

    // Archivos permanentes
    escritura: null,
    comprobante_domicilio: null,
    predial: null,
    seguro: null,
    contrato_luz: null,
    contrato_agua: null,

    // Hipoteca
    compra_venta: null,
    banco: "",
    titular_hipoteca: "",
    amortizacion: null,
    seguro_mortgage: null,
    start_date: "",
    end_date: "",
    pago_mensual: "",

    // Renta
    isAval: true,
    contrato_renta: null,
    date_start: "",
    date_end: "",
    ine_inquilino: null,
    datos_facturacion: null,
    poliza_juridica: null,
    ine_aval: null,
    comprobante_aval: null,
    userId: "",
    monto: "",
    iva: "",
    subtotal: "",
    fac_razonSocial: "",
    fac_rfc: "",
    fac_usoCFDI: "",
    fac_email: "",
    create: false,

    // user
    userName: "",
    userEmail: "",
    userCellphone: "",
};

export const validationSchemaInmueble = Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
    address: Yup.string().required("La dirección es obligatoria"),
    type: Yup.string().required("La clasificación es obligatoria"),
    real_estate: Yup.number().required("El ID de la inmobiliaria es obligatorio"),

    // Archivos permanentes
    escritura: Yup.mixed().notRequired(),
    contrato_agua: Yup.mixed().notRequired(),
    contrato_luz: Yup.mixed().notRequired(),
    comprobante_domicilio: Yup.mixed().notRequired(),
    predial: Yup.mixed().notRequired(),

    // Hipoteca condicional
    start_date: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Fecha de inicio obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    pago_mensual: Yup.number()
        .typeError("El monto debe ser un número")
        .positive("El monto debe ser positivo")
        .when("isMortgaged", {
            is: true,
            then: (schema) => schema.required("El monto es obligatorio"),
            otherwise: (schema) => schema.notRequired(),
        }),
    end_date: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Fecha de fin obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    compra_venta: Yup.mixed().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Contrato obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    banco: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Banco obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    titular_hipoteca: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Titular obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    amortizacion: Yup.mixed().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Tabla de amortización obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    seguro_mortgage: Yup.mixed().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("El seguro es obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),

    // Renta condicional
    contrato_renta: Yup.mixed().when("isRented", {
        is: true,
        then: (schema) => schema.required("Contrato de renta obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    ine_inquilino: Yup.mixed().when("isRented", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
    }),
    poliza_juridica: Yup.mixed().when(["isRented", "isAval"], {
        is: (isRented, isAval) => isRented && !isAval,
        then: (schema) => schema.required("Poliza jurídica obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    ine_aval: Yup.mixed().when(["isRented", "isAval"], {
        is: (isRented, isAval) => isRented && isAval,
        then: (schema) => schema.required("INE del Aval obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    comprobante_aval: Yup.mixed().when(["isRented", "isAval"], {
        is: (isRented, isAval) => isRented && isAval,
        then: (schema) =>
            schema.required("Comprobante de domicilio del Aval obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userId: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === false,
        then: (schema) => schema.required("Inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userCellphone: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === true,
        then: (schema) => schema.required("Teléfono del inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userEmail: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === true,
        then: (schema) => schema.required("Email del inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userName: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === true,
        then: (schema) => schema.required("Nombre del inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    monto: Yup.number()
        .typeError("El monto debe ser un número")
        .positive("El monto debe ser positivo")
        .when("isRented", {
            is: true,
            then: (schema) => schema.required("El monto es obligatorio"),
            otherwise: (schema) => schema.notRequired(),
        }),
    iva: Yup.number()
        .typeError("El IVA debe ser un número")
        .min(0, "El IVA no puede ser negativo")
        .when("isRented", {
            is: true,
            then: (schema) => schema.required("El IVA es obligatorio"),
            otherwise: (schema) => schema.notRequired(),
        }),
    subtotal: Yup.number()
        .typeError("El subtotal debe ser un número")
        .positive("El subtotal debe ser positivo")
        .when("isRented", {
            is: true,
            then: (schema) => schema.required("El subtotal es obligatorio"),
            otherwise: (schema) => schema.notRequired(),
        }),
    date_start: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("Fecha de inicio obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    date_end: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("Fecha de fin obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_email: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_razonSocial: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_rfc: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_usoCFDI: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
    }),
});
